import React from "react";
import { motion } from "framer-motion";
import { coursesAnimation } from "../animate";
import { useScroll } from "./useScroll";
import useWindowDimensions from "./useDimension";

const FAQ = () => {
  const { width } = useWindowDimensions();
  const [element, controls] = useScroll(width < 1000 ? 0.25 : 0.3);
  return (
    <motion.div
      variants={coursesAnimation}
      ref={element}
      initial="hidden"
      animate={controls}
      className="faq"
    >
      <h2>
        <span>常見問題</span>
      </h2>

      <div className="question">
        <h4>
          課程在<span>Udemy</span>網路平台上面，但Udemy是什麼樣的網站?
        </h4>
        <p>
          Udemy 是一個全球知名的線上學習平台，擁有超過 13 萬門課程與 3,500
          萬名學習者。使用者可以在平台上學習各種專業技能與知識，涵蓋程式設計、資料科學、商業等多元領域。Udemy
          也提供完善的學習系統，包含課程進度追蹤、程式練習與測驗功能，幫助學習者更有效地掌握內容與提升實作能力。
        </p>
        <div className="line"></div>
      </div>

      <div className="question">
        <h4>
          <span>課程費用</span>怎麼計算? 退費怎麼處理?
        </h4>
        <p>
          課程費用根據Udemy定價為準，註冊一次即可終身使用課程，並且在完成課程時給予證書。在此網站中也可以找到Wilson
          Ren的課程<span>專屬優惠碼，可以折價為新台幣300到470元不等</span>。
        </p>
        <p>
          退費手續為Udemy網站之規定，須遵守網站退費流程，並且在註冊後的30天內辦理退費。
        </p>
        <div className="line"></div>
      </div>

      <div className="question">
        <h4>
          課程難度高嗎? 我需要有 <span>相關學歷或程式背景</span>嗎?
        </h4>
        <p>
          課程是設計給任何程度的學習者，<span>不論你的學歷或背景為何</span>
          ，都可以深入淺出的學習Wilson
          Ren的任何課程。課程在設計與錄製時，都是經過考慮與規劃，採用最容易吸收的教學方式，深入學習所有內容。
        </p>
        <p>
          若是對於學習內容有疑惑，也可以在提問區提出問題，講師通常在一天之內會及時回復解答，為學生解除疑惑。
        </p>
        <div className="line"></div>
      </div>
      <div className="question">
        <h4>
          沒有任何學習寫程式的經驗，這麼多課程我該<span>先學習哪一個</span>?
        </h4>
        <p style={{ marginBottom: "10px" }}>
          <span>資料科學、人工智能</span>
          是目前最熱門的領域之一，廣泛應用於金融、醫療、科技與各種產業中，正在快速改變世界的運作方式。從
          Python
          基礎開始，依序完成機器學習、深度學習課程，將幫助你建立堅實的AI基礎，掌握核心技術與實戰技能，為未來職涯打下堅實的基礎。
        </p>
        <p style={{ marginBottom: "10px" }}>
          <span>網頁開發課程</span>
          適合所有初學者從零開始學習。相較於其他程式語言（如 C++、Java
          等），網頁開發能更快看到成果，學習過程更具成就感，也非常適合作為程式入門的第一步。此外，全端開發是目前市場上需求量很大的技能，學習網頁開發將為你打開廣闊的職業機會。
        </p>
        <p>
          <span>資料結構與演算法</span>
          是所有工程師面試中幾乎一定會出現的核心題目。若目標是進入軟體工程相關領域，這門課程絕對是必備基礎。課程將介紹電腦如何高效儲存與處理資料，並學習如何根據不同資料型態與需求選擇合適的資料結構與演算法。同時也會涵蓋常見的演算法設計，例如排序、搜尋、圖論中的最短路徑問題，以及動態規劃等面試必考重點。
        </p>
        <div className="line"></div>
      </div>
    </motion.div>
  );
};

export default FAQ;
